import http from '@/utils/http';

// 登录
export const getSession = (data) => {
    return http({
        url: '/api/can/v2/session/lp',
        method: 'post',
        data: data
    });
};

// 获取图形验证码
export function getCaptcha(params) {
    return http({
        url: '/api/can/v2/captcha',
        responseType: 'blob',
        // url:'/sys/randomImage/',
        method: "get",
        params
    })
}
export function publicKeyAPI() {
    return http({
        url: '/api/can/v2/session/public-key',
        method: 'get',
    })
}